"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyScrollSnap = void 0;
var styled_components_1 = require("styled-components");
exports.applyScrollSnap = function (_a) {
    var scrollSnapAlign = _a.scrollSnapAlign;
    return scrollSnapAlign && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        scroll-snap-align: ", ";\n    "], ["\n        scroll-snap-align: ", ";\n    "])), scrollSnapAlign);
};
var templateObject_1;
//# sourceMappingURL=applyScrollSnap.js.map